import {
  Home,
  Users,
  Building2,
  CalendarDays,
  Map as MapIcon,
  ClipboardList,
  FileText,
  Search,
  BarChart3,
  Package,
  MapPin,
  Sliders,
  LayoutGrid,
  UserCog,
  Activity,
} from 'lucide-react';

export const ZONES = {
  dispatch: {
    id: 'dispatch',
    label: 'Dispatch',
    description: 'Schedule, assign, and field calls',
    defaultPath: '/dispatch',
  },
  invoicing: {
    id: 'invoicing',
    label: 'Invoicing',
    description: 'Clean up and finalize completed work',
    defaultPath: '/invoicing',
  },
  management: {
    id: 'management',
    label: 'Management',
    description: 'Users, reports, inventory, and settings',
    defaultPath: '/customers',
  },
};

export const DISPATCH_VIEWS = {
  calendar: { id: 'calendar', label: 'Calendar', shortcut: '1', icon: CalendarDays },
  board: { id: 'board', label: 'Board', shortcut: '2', icon: LayoutGrid },
  map: { id: 'map', label: 'Map', shortcut: '3', icon: MapIcon },
  today: { id: 'today', label: 'Today', shortcut: '4', icon: Activity },
};

export const DISPATCH_VIEW_STORAGE_KEY = 'hubDispatchView';

export const dispatchNav = [
  { name: 'Dispatch', href: '/dispatch', icon: Home },
  { name: 'Parts Needed', href: '/parts-needed', icon: ClipboardList, badgeKey: 'parts' },
];

export const invoicingNav = [
  { name: 'To Finalize', href: '/invoicing', icon: FileText, badgeKey: 'toFinalize' },
  { name: 'Service Call Lookup', href: '/service-calls', icon: Search },
];

export const managementNav = [
  { name: 'Customers & Sites', href: '/customers', icon: Building2, badgeKey: 'pendingClients' },
  { name: 'Users', href: '/users', icon: Users },
  { name: 'Tech Scheduling', href: '/tech-scheduling', icon: UserCog },
  { name: 'Reports', href: '/reports', icon: BarChart3 },
  { name: 'Inventory', href: '/inventory', icon: Package },
  { name: 'Inventory Locations', href: '/inventory-locations', icon: MapPin },
  { name: 'Settings', href: '/settings', icon: Sliders, requiresAdvancedSettings: true },
];

const pathZoneMap = {
  '/dispatch': 'dispatch',
  '/regular-service': 'dispatch',
  '/tech-assignments': 'dispatch',
  '/priority-service': 'dispatch',
  '/schedule': 'dispatch',
  '/map': 'dispatch',
  '/parts-needed': 'dispatch',
  '/invoicing': 'invoicing',
  '/service-calls': 'invoicing',
  '/customers': 'management',
  '/clients': 'management',
  '/users': 'management',
  '/tech-scheduling': 'management',
  '/reports': 'management',
  '/monthly-roster': 'management',
  '/tech-metrics': 'management',
  '/service-history': 'management',
  '/inventory': 'management',
  '/inventory-locations': 'management',
  '/settings': 'management',
  '/advanced-settings': 'management',
  '/profile': null,
};

export const getZoneForPath = (pathname) => pathZoneMap[pathname] ?? 'dispatch';

export const getNavForZone = (zoneId) => {
  switch (zoneId) {
    case 'invoicing':
      return invoicingNav;
    case 'management':
      return managementNav;
    default:
      return dispatchNav;
  }
};

export const ZONE_STORAGE_KEY = 'adminActiveZone';

export const isNavItemActive = (item, pathname) =>
  pathname === item.href
  || (item.href === '/dispatch' && ['/dispatch', '/schedule', '/map'].includes(pathname))
  || (item.href === '/customers' && pathname === '/clients')
  || (item.href === '/settings' && pathname === '/advanced-settings');
